"use client";

import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { apiClient } from "@/lib/api-client";

type Props<T> = {
  queryKey: string[];
  url: string;
  params?: Record<string, unknown>;
  options?: Omit<UseQueryOptions<T>, "queryKey" | "queryFn">;
  /** Remplace le GET `apiClient` (mock, agrégation, etc.). */
  queryFn?: () => Promise<T>;
};

export function useApiQuery<T>({
  queryKey,
  url,
  params,
  options,
  queryFn: customQueryFn,
}: Props<T>) {
  return useQuery<T>({
    queryKey,
    queryFn:
      customQueryFn ?? (() => apiClient.get<T>(url, params)),
    ...options,
  });
}